import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Printer, ArrowLeft, Download, Share2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useCertificate, CertificateArt, formatDate } from "@/components/CertificateKit";

export default function Certificate() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [c, setC] = useState(null);
  const [prog, setProg] = useState(null);
  const [name, setName] = useState(`The ${user?.first_name || ""} Family`);
  const kit = useCertificate(slug, c?.title || "");
  const { busy, download, share } = kit;
  useEffect(() => {
    api.get(`/challenges/${slug}`).then((r) => setC(r.data));
    api.get(`/me/challenges/${slug}`).then((r) => setProg(r.data));
  }, [slug]);
  if (!c || !prog) return <div className="min-h-[60vh]" />;
  const finished = prog.days_done.length >= c.days.length;
  if (!finished)
    return (
      <div className="container-bt py-24 text-center" data-testid="certificate-locked">
        <h1 className="text-4xl">Almost there</h1>
        <p className="mt-4">Finish all {c.days.length} days to unlock your certificate. You've done {prog.days_done.length}.</p>
        <Link to={`/challenge/${slug}`} className="btn-primary mt-8">Back to the challenge</Link>
      </div>
    );
  const date = formatDate(prog.finished_at || prog.updated_at);
  return (
    <div className="container-bt py-10 print:p-0" data-testid="certificate-page">
      <style>{"@page { size: A4 landscape; margin: 10mm; } @media print { body { background: #fff; -webkit-print-color-adjust: exact; print-color-adjust: exact; } }"}</style>
      <div className="mx-auto mb-8 flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-end print:hidden">
        <Link to={`/challenge/${slug}`} className="btn-ghost -ml-4"><ArrowLeft size={16} /> Challenge</Link>
        <div className="flex-1">
          <label className="mb-2 block text-sm font-semibold text-bt-heading">Name on the certificate</label>
          <input className="input-bt" value={name} onChange={(e) => setName(e.target.value)} data-testid="certificate-name-input" />
        </div>
      </div>
      <div className="mx-auto mb-8 grid max-w-4xl gap-3 sm:grid-cols-3 print:hidden">
        <button onClick={share} disabled={busy} className="btn-primary" data-testid="certificate-share-button"><Share2 size={18} /> Share</button>
        <button onClick={download} disabled={busy} className="btn-secondary" data-testid="certificate-download-button"><Download size={18} /> {busy ? "Creating..." : "Download image"}</button>
        <button onClick={() => window.print()} className="btn-secondary" data-testid="certificate-print-button"><Printer size={18} /> Print or PDF</button>
      </div>
      <CertificateArt c={c} name={name} date={date} kit={kit} className="mx-auto max-w-4xl" />
    </div>
  );
}
